/**
 *
 *  ? url pada submenu menggunakana naming routes,
 *  ? jadi tidak perlu dibuat format url lengkap
 */
export default [
  {
    icon: "BookIcon",
    menu: "Turnitin",
    url: "perpustakaan-turnitin",
  },
];
